
import React, {useState} from "react";

import {FontAwesomeIcon}
from "@fortawesome/react-fontawesome";

import {
    UTILISATION_DASHBOARD_TYPE_SOL,
    UTILISATION_DASHBOARD_TYPE_ACTIVITY
}
from "../../../constants/general-constants";

import UtilisationOrganisationNavigatorTab
from "../components/UtilisationOrganisationNavigatorTab";

import {useHistory}
from "react-router-dom";


import { OMNISCAN_BLUE } from "../../../constants/colors";


//========================================================
// OMNISCAN PRO
// UTILISATION ORGANISATION NAVIGATOR
//
// Unified architectural blue
//========================================================

export default function UtilisationOrganisationNavigator({
    dashboardType,
    selectedParentSpaceTypeId
})
{


    //----------------------------------------------------
    // Navigation
    //----------------------------------------------------

    const history = useHistory();


    //----------------------------------------------------
    // State
    //----------------------------------------------------

    const [isHover, setIsHover] =
        useState(false);


    //----------------------------------------------------
    // Go To Utilisation Summary
    //----------------------------------------------------

    const goHome = () =>
    {
        history.push("/homeutilisation/-100");
    };


    //----------------------------------------------------
    // Container
    //----------------------------------------------------

    const thisContainer =
    {
        position: "fixed",
        top: "52px",
        left: 300,
        right: 300,
        height: "44px",

        display: "flex",
        justifyContent: "center",

        backgroundColor: "#FAFBFC",

        zIndex: 20000,

        borderBottom: "1px solid #E6EAF0",
        borderRadius: "8px"
    };


    //----------------------------------------------------
    // Organisation Tabs
    //----------------------------------------------------

    const organisations =
    [
        {
            id: "1",
            label: "Focus",
            icon: "desktop",
            color: OMNISCAN_BLUE,
            dashboardType: UTILISATION_DASHBOARD_TYPE_SOL
        },
        {
            id: "5",
            label: "Technical Spaces",
            icon: "film",
            color: OMNISCAN_BLUE,
            dashboardType: UTILISATION_DASHBOARD_TYPE_ACTIVITY
        },
        {
            id: "3",
            label: "Meeting Rooms",
            icon: "users",
            color: OMNISCAN_BLUE,
            dashboardType: UTILISATION_DASHBOARD_TYPE_ACTIVITY
        },
        {
            id: "4",
            label: "Alternative",
            icon: "couch",
            color: OMNISCAN_BLUE,
            dashboardType: UTILISATION_DASHBOARD_TYPE_ACTIVITY
        },
        {
            id: "2",
            label: "Social",
            icon: "utensils",
            color: OMNISCAN_BLUE,
            dashboardType: UTILISATION_DASHBOARD_TYPE_ACTIVITY
        }
    ];


    //----------------------------------------------------
    // Render Organisation Tabs
    //----------------------------------------------------

    const organisationDisplay =
        organisations.map(
            (item) =>
            (
                <UtilisationOrganisationNavigatorTab
                    key={item.id}
                    spaceTypeId={item.id}
                    icon={item.icon}
                    label={item.label}
                    color={item.color}
                    dashboardType={item.dashboardType}
                    selectedParentSpaceTypeId={
                        selectedParentSpaceTypeId
                    }
                />
            )
        );


    //----------------------------------------------------
    // Summary Tab
    //----------------------------------------------------

    const organisationTab =
    {
        cursor: "pointer",

        display: "flex",

        width: "180px",
        height: "42px",

        alignItems: "center",
        justifyContent: "center",

        background:
            "linear-gradient(180deg, #ffffff 0%, #f4f6f9 100%)",

        borderRadius: "8px",

        boxShadow: isHover
            ? "0 4px 10px rgba(0,0,0,0.08)"
            : "none",

        transform: isHover
            ? "scale(1.03)"
            : "scale(1)",

        transition: "all 0.2s ease",

        position: "relative"
    };


    //----------------------------------------------------
    // Summary Icon
    //----------------------------------------------------

    const organisationIcon =
    {
        marginRight: "8px",

        width: "18px",
        height: "18px",

        color: OMNISCAN_BLUE,

        transition: "all 0.2s ease"
    };


    //----------------------------------------------------
    // Summary Title
    //----------------------------------------------------

    const organisationTitle =
    {
        fontSize: "14px",

        fontWeight: "500",

        color: isHover
            ? OMNISCAN_BLUE
            : "#6b7280",

        transition: "all 0.2s ease"
    };


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (
        <div style={thisContainer}>

            <div
                style={{
                    display: "flex",

                    width: "900px",
                    height: "44px",

                    alignItems: "center",

                    borderBottomLeftRadius: "14px",
                    borderBottomRightRadius: "14px"
                }}
            >

                {/*----------------------------------------
                  Utilisation Summary
                ----------------------------------------*/}

                <div
                    style={organisationTab}
                    onClick={goHome}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                >

                    <FontAwesomeIcon
                        icon="chart-bar"
                        style={organisationIcon}
                    />

                    <div style={organisationTitle}>
                        Utilisation Summary
                    </div>

                </div>


                {/*----------------------------------------
                  Organisation Navigation
                ----------------------------------------*/}

                {organisationDisplay}

            </div>

        </div>
    );
}
